export const packages = [
  //قیمت پکیج باید اصلاح شود
  {
    packId: 11,
    title: 'بسته ارگانیک',
    priceAfterDiscount: 2169680,
    priceBeforeDiscount: '',
    discount: 248320,
    items: [
      {
        SPID: 8335,
        ArticleID: 9173,
        QTY: 2,
        name: 'شیر ارگانیک برند آقای طبیعی کامل حجم ۹۴۵ سی سی',
        price: 151680,
        image: ''
      },
      {
        SPID: 1045,
        ArticleID: 7378,
        QTY: 1,
        name: 'چای سیاه ممتاز ارگانیک زوبین ۴۰۰ گرمی',
        price: 517500,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 4011,
        QTY: 2,
        name: 'خرمای مضافتی ارگانیک مانادیت ۶۵۰ گرمی',
        price: 629000,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 5504,
        QTY: 1,
        name: 'عسل ارگانیک گون گزمدا ۵۰۰ گرمی',
        price: 472500,
        image: ''
      }
      // {
      //     SPID: 1041,
      //     ArticleID: 7999,
      //     QTY: 1,
      //     name: 'برنج قهوه ای ارگانیک شکرالله پور ۱ کیلوگرمی',
      //     price: 399000,
      //     image: ''
      // },
    ]
  },
  {
    packId: 12,
    title: 'بسته پروتئین خانواده',
    priceAfterDiscount: 2399579,
    priceBeforeDiscount: '',
    discount: 321831,
    items: [
      {
        SPID: 8335,
        ArticleID: 2119,
        QTY: 1,
        name: 'گوشت چرخ کرده مخلوط گوساله و گوسفند ممتاز ۱ کیلویی مهیا پروتئین',
        price: 553690,
        image: ''
      },
      {
        SPID: 1045,
        ArticleID: 4954,
        QTY: 1,
        name: 'تخم مرغ برند تلاونگ شانه ۲۰ عددی',
        price: 216600,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 4454,
        QTY: 1,
        name: 'مرغ تازه خرد شده بدون پوست بسته بندی بی تا ۸۰۰ گرمی',
        price: 194589,
        image: ''
      },
      // {
      //     SPID: 1041,
      //     ArticleID: 5504,
      //     QTY: 1,
      //     name: 'عسل ارگانیک گون گزمدا ۵۰۰ گرمی',
      //     price: 472500,
      //     image: ''
      // },
      {
        SPID: 1041,
        ArticleID: 1019,
        QTY: 1,
        name: 'ژامبون مرغ دودی ۹۰% نامی نو ۲۰۰ گرمی',
        price: 97750,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 5429,
        QTY: 1,
        name: 'ناگت مرغ و پنیر منجمد ب.آ ۲۵۰ گرمی',
        price: 118150,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 9578,
        QTY: 1,
        name: 'همبرگر زغالی ۹۰% گوشت گوشتیران ۵۰۰گرمی',
        price: 340850,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 2113,
        QTY: 1,
        name: 'ران گوساله ممتاز ۱ کیلویی مهیا پروتئین',
        price: 877950,
        image: ''
      }
    ]
  },
  //قیمت پکیج باید اصلاح شود
  {
    packId: 13,
    title: 'بسته تنقلات',
    priceAfterDiscount: 2032100,
    priceBeforeDiscount: '',
    discount: 206900,
    items: [
      {
        SPID: 8335,
        ArticleID: 10907,
        QTY: 1,
        name: 'شیرینی عسلی مهسا برند محجوب(نانبرسان) وزن ۸۰۰ گرمی',
        price: 175000,
        image: ''
      },
      {
        SPID: 1045,
        ArticleID: 4979,
        QTY: 1,
        name: 'چیابار گرانولابار',
        price: 142500,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 5304,
        QTY: 1,
        name: 'بچه هویج برند تازه وزن ۴۵۰ گرمی',
        price: 95000,
        image: ''
      },
      // {
      //     SPID: 1041,
      //     ArticleID: 5504,
      //     QTY: 1,
      //     name: 'عسل ارگانیک گون گزمدا ۵۰۰ گرمی',
      //     price: 472500,
      //     image: ''
      // },
      {
        SPID: 1041,
        ArticleID: 7689,
        QTY: 1,
        name: 'شکلات ۹۶% تلخ پاکتی ۳۲۰ گرمی پارمیدا',
        price: 584100,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 10630,
        QTY: 1,
        name: 'پسته اکبری دستچین شور ممتاز سبات ۳۰۰ گرمی',
        price: 598500,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 10132,
        QTY: 1,
        name: 'تخمه جابانی بوداده سبات ۳۰۰ گرمی',
        price: 190000,
        image: ''
      },
      {
        SPID: 1041,
        ArticleID: 6700,
        QTY: 1,
        name: 'ترافل خرمایی مخلوط برنا ۶۰۰ گرمی ۴۰ عددی',
        price: 247000,
        image: ''
      }
    ]
  },
  {
    packId: 14,
    title: 'بسته شام ۱',
    priceAfterDiscount: 2079050,
    priceBeforeDiscount: '',
    discount: 329950,
    items: [
      {
        SPID: 8335,
        ArticleID: 1028,
        QTY: 1,
        name: 'سالاد مرغ نامی نو ۵۰۰ گرمی',
        price: 212500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5,
        QTY: 1,
        name: 'کشک و بادمجان نامی نو ۵۰۰ گرمی',
        price: 148750,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 9661,
        QTY: 2,
        name: 'شنیسل مرغ گوشتیران ۱۰۰۰گرمی',
        price: 724200,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5707,
        QTY: 1,
        name: 'کباب لقمه منجمد ب.آ ۴۰۰ گرمی',
        price: 279650,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 7715,
        QTY: 1,
        name: 'میگو پلویی برند زرافشان جنوب منجمد وزن ۵۰۰ گرمی',
        price: 565200,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 1030,
        QTY: 1,
        name: 'خوراک سوسیس بندری با قارچ نامی نو ۵۰۰ گرمی',
        price: 148750,
        image: ''
      }
    ]
  },
  {
    packId: 15,
    title: 'بسته شام 2',
    priceAfterDiscount: 2039325,
    priceBeforeDiscount: '',
    discount: 320175,
    items: [
      {
        SPID: 8335,
        ArticleID: 9578,
        QTY: 1,
        name: 'همبرگر زغالی ۹۰% گوشت گوشتیران ۵۰۰گرمی',
        price: 340850,
        image: ''
      },
      {
        SPID: 5634,
        ArticleID: 5533,
        QTY: 2,
        name: 'نان همبرگر برش خورده سه نان ۱۶۰ گرمی',
        price: 72200,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8936,
        QTY: 1,
        name: 'سالاد فصل افرا برند بامیکا وزن ۲۵۰ گرمی',
        price: 56050,
        image: ''
      },
      {
        SPID: 5,
        ArticleID: 5,
        QTY: 1,
        name: 'کشک و بادمجان نامی نو ۵۰۰ گرمی',
        price: 148750,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3387,
        QTY: 2,
        name: 'نان لواش روستا متوسط نان آوران ۱۸۰ گرمی',
        price: 279650,
        image: ''
      },
      // {
      //     SPID: 8335,
      //     ArticleID: 7715,
      //     QTY: 2,
      //     name: 'میگو پلویی برند زرافشان جنوب منجمد وزن ۵۰۰ گرمی',
      //     price: 34200,
      //     image: ''
      // },
      {
        SPID: 8335,
        ArticleID: 5553,
        QTY: 1,
        name: 'شامی کباب گوشت منجمد ب.آ ۴۵۰ گرمی',
        price: 211650,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2166,
        QTY: 1,
        name: 'جوانه میکس ممتاز توتیا ۲۰۰ گرمی',
        price: 58650,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8504,
        QTY: 1,
        name: 'قارچ دکمه ای ممتاز قارچینو ۴۰۰ گرمی',
        price: 132525,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 7590,
        QTY: 1,
        name: 'پنیر پروسس تست ماردینی ۱۸۰ گرمی',
        price: 109250,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5579,
        QTY: 1,
        name: 'سیب زمینی تنوری منجمد ب.آ ۹۵۰ گرمی',
        price: 127500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8797,
        QTY: 1,
        name: 'کوردن بلو منجمد ۵۰۰ گرمی مارین',
        price: 284800,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8658,
        QTY: 1,
        name: 'آبمیوه گازداربرند عالیس انگور قرمز شیشه ۲۵۰ سی سی باکس ۱۲عددی',
        price: 377400,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 6411,
        QTY: 2,
        name: 'نان نسیم پرونان نان آوران ۲۳۰ گرمی',
        price: 85500,
        image: ''
      }
    ]
  },
  {
    packId: 16,
    title: 'بسته صبحانه خانواده',
    priceAfterDiscount: 2128600,
    priceBeforeDiscount: '',
    discount: 199400,
    items: [
      {
        SPID: 8335,
        ArticleID: 5530,
        QTY: 1,
        name: 'نان تافتون سبوس سه نان ۴۵۰ گرمی',
        price: 38000,
        image: ''
      },
      {
        SPID: 5533,
        ArticleID: 2588,
        QTY: 1,
        name: 'شیر استریل پاکتی ۱/۵درصد تتراپک اسکوئر پگاه ۱ لیتری',
        price: 66500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2574,
        QTY: 1,
        name: 'شیر کاکائو استریل پاکتی اسکوئر پگاه ۱ لیتری',
        price: 95000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5528,
        QTY: 1,
        name: 'نان تست هفت غله سه نان ۵۳۰ گرمی',
        price: 85500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2624,
        QTY: 6,
        name: 'کره پگاه ۱۰۰ گرمی',
        price: 256500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4954,
        QTY: 1,
        name: 'تخم مرغ برند تلاونگ شانه ۲۰ عددی',
        price: 216600,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2525,
        QTY: 1,
        name: 'پنیر تازه پاستوریزه نسبتا چرب پگاه ۴۵۰ گرمی',
        price: 90250,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3005,
        QTY: 1,
        name: 'خامه استریل پاکتی کامی بلاک پگاه ۲۰۰ سی سی',
        price: 57000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2516,
        QTY: 1,
        name: 'پنیر خامه ای لیوانی پگاه ۴۰۰گرمی',
        price: 118750,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 7795,
        QTY: 1,
        name: 'شکلات صبحانه فندقی ۴۰۰ گرمی پارمیدا',
        price: 342000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 10461,
        QTY: 1,
        name: 'پک ارده ممتاز ۴۰۰گرمی و شیره انگور ۳۰۰ گرمی بیسفود',
        price: 544000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 9263,
        QTY: 1,
        name: 'عسل چند گیاه دشتی نقره ای بندار ۳۰۰ گرمی',
        price: 218500,
        image: ''
      }
    ]
  },
  {
    packId: 17,
    title: 'بسته لبنیات خانواده',
    priceAfterDiscount: 1679600,
    priceBeforeDiscount: '',
    discount: 88400,
    items: [
      {
        SPID: 8335,
        ArticleID: 2622,
        QTY: 6,
        name: 'کره پگاه ۵۰ گرمی',
        price: 131100,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3005,
        QTY: 2,
        name: 'خامه استریل پاکتی کامی بلاک پگاه ۲۰۰ سی سی',
        price: 114000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2525,
        QTY: 2,
        name: 'پنیر تازه پاستوریزه نسبتا چرب پگاه ۴۵۰ گرمی',
        price: 180500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2588,
        QTY: 2,
        name: 'شیر استریل پاکتی ۱/۵درصد تتراپک اسکوئر پگاه ۱ لیتری',
        price: 133000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2574,
        QTY: 2,
        name: 'شیر کاکائو استریل پاکتی اسکوئر پگاه ۱ لیتری',
        price: 190000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2610,
        QTY: 1,
        name: 'ماست دبه ای ۳ درصد پگاه ۲۲۰۰ گرمی',
        price: 133000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2513,
        QTY: 2,
        name: 'دوغ کفیر بطری پت پگاه ۱/۵ لیتری',
        price: 152000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2459,
        QTY: 1,
        name: 'پنیر بلغاری آی ام ال پگاه ۴۰۰ گرمی',
        price: 237500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2608,
        QTY: 1,
        name: 'ماست سطلی ۴/۲درصد آی ام ال پگاه ۲۲۰۰ گرمی',
        price: 171000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2516,
        QTY: 2,
        name: 'پنیر خامه ای لیوانی پگاه ۴۰۰گرمی',
        price: 237500,
        image: ''
      }
    ]
  },
  {
    packId: 18,
    title: 'بسته میان وعده',
    priceAfterDiscount: 2035500,
    priceBeforeDiscount: '',
    discount: 384500,
    items: [
      {
        SPID: 8335,
        ArticleID: 10586,
        QTY: 1,
        name: 'ساندویچ برند نامی نو الویه مرغ ۱۳۰ گرمی نیم باگت',
        price: 72000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8768,
        QTY: 1,
        name: 'سس گوجه فرنگی با هالوپینو پیلی پیلی ۲۵۰ گرمی',
        price: 111000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 1007,
        QTY: 1,
        name: 'ساندویچ برند نامی نو فیله مرغ با پنیر ۱۳۰ گرمی',
        price: 80000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 1013,
        QTY: 1,
        name: 'سالاد مرغ نامی نو ۲۰۰ گرمی',
        price: 106250,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3490,
        QTY: 4,
        name: 'پیراشکی مغزدار تکی نان آوران ۶۰ گرمی',
        price: 76000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3503,
        QTY: 1,
        name: 'نان اشترودل وانیل نان آوران ۷۵ گرمی',
        price: 28500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3502,
        QTY: 1,
        name: 'نان اشترودل شکلات نان آوران ۷۵ گرمی',
        price: 28500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3388,
        QTY: 2,
        name: 'نان کروسان شکلاتی نان آوران ۶۰ گرمی',
        price: 57000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 3492,
        QTY: 2,
        name: 'کیک گردویی -کشمشی نان آوران ۸۵ گرمی',
        price: 66500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2574,
        QTY: 1,
        name: 'شیر کاکائو استریل پاکتی اسکوئر پگاه ۱ لیتری',
        price: 95000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2403,
        QTY: 1,
        name: 'تیرامیسو شارلوت۸۰۰ گرمی',
        price: 280000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 10471,
        QTY: 1,
        name: 'دسر داب لبو ۱۸۰۰ گرمی Sweet life',
        price: 180000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5230,
        QTY: 1,
        name: 'سمنو ویژه جوانه فرد ۵۰۰ گرمی',
        price: 112000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8643,
        QTY: 1,
        name: 'نوشابه برند عالیس با طعم لیمو ۱/۵لیتری باکس ۶ عددی',
        price: 242250,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5101,
        QTY: 1,
        name: 'سفیده مایع تخم مرغ برند تلاونگ پاستوریزه حجم ۳۵۰ سی سی',
        price: 90250,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4992,
        QTY: 1,
        name: 'ساندویچ سفیده تخم مرغ برند تلاونگ(تلاویچ) وزن ۱۷۰ گرمی',
        price: 85500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4965,
        QTY: 1,
        name: 'ساندویچ سفیده تخم مرغ برند تلاونگ(تلاویچ) فلفلی وزن ۱۷۰ گرمی',
        price: 90250,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 10105,
        QTY: 1,
        name: 'کرم کنجد شکلاتی با تکه های فندق رامونا ۱۸۰ گرمی',
        price: 184500,
        image: ''
      }
    ]
  },
  {
    packId: 19,
    title: 'بسته ناهار',
    priceAfterDiscount: 1668786,
    priceBeforeDiscount: '',
    discount: 341014,
    items: [
      {
        SPID: 8335,
        ArticleID: 5,
        QTY: 2,
        name: 'کشک و بادمجان نامی نو ۵۰۰ گرمی',
        price: 297500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2129,
        QTY: 1,
        name: 'گوشت قیمه ای گوساله ۵۰۰ گرمی مهیا پروتئین',
        price: 532336,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 9812,
        QTY: 1,
        name: 'لپه کیاست ۸۰۰ گرمی',
        price: 298300,
        image: ''
      },
      // {
      //     SPID: 8335,
      //     ArticleID: 2407,
      //     QTY: 1,
      //     name: 'سبزی خوردن برند دکتربیژن بسته ای وزن ۱۸۰ گرمی',
      //     price: 64000,
      //     image: ''
      // },
      {
        SPID: 8335,
        ArticleID: 2518,
        QTY: 2,
        name: 'دوغ گازدار با طعم نعنا پگاه ۱/۵ لیتری',
        price: 133000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 9459,
        QTY: 1,
        name: 'زیتون شور درشت ۶۶۰ گرمی sweet life',
        price: 210000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4661,
        QTY: 1,
        name: 'سیب زمینی خلال منجمد (۱۰*۱۰) ۷۵۰ گرمی نوبرسبز',
        price: 89325,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4631,
        QTY: 1,
        name: 'لوبیا سبز خرد شده منجمد ۴۰۰ گرمی نوبرسبز',
        price: 44325,
        image: ''
      }
    ]
  },
  //قیمت پکیج باید اصلاح شود
  {
    packId: 20,
    title: 'بسته ویژه کدبانو',
    priceAfterDiscount: 1998200,
    priceBeforeDiscount: '',
    discount: 502400,
    items: [
      {
        SPID: 8335,
        ArticleID: 2073,
        QTY: 1,
        name: 'سینه مرغ بدون پوست ۹۰۰ گرمی مهیا پروتئین',
        price: 227100,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4776,
        QTY: 1,
        name: 'زیتون بی هسته کم نمک سایز سوپر ویژه دلفین ۲۷۰ گرمی',
        price: 161500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 2082,
        QTY: 1,
        name: 'ران مرغ بدون پوست ۹۰۰ گرمی مهیا پروتئین',
        price: 210500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4661,
        QTY: 1,
        name: 'سیب زمینی خلال منجمد (۱۰*۱۰) ۷۵۰ گرمی نوبرسبز',
        price: 89325,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4715,
        QTY: 1,
        name: 'زیتون پرورده ویژه(پرگردو) دلفین ۲۵۰ گرمی',
        price: 161500,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5430,
        QTY: 1,
        name: 'ناگت مرغ و پنیر منجمد ب.آ ۹۵۰ گرمی',
        price: 452200,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 1033,
        QTY: 1,
        name: 'سس کچاپ نامی نو ۱۲۰۰ گرمی',
        price: 96000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8771,
        QTY: 1,
        name: 'سس لیمو و سبزیجات معطر پیلی پیلی ۲۵۰ گرمی',
        price: 111000,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 4658,
        QTY: 2,
        name: 'پیاز سرخ شده خلالی منجمد ۲۰۰ گرمی نوبرسبز',
        price: 258750,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 5249,
        QTY: 1,
        name: 'مخلوط سبزیجات زیبا منجمد ۴۰۰ گرمی نوبرسبز',
        price: 53325,
        image: ''
      },
      {
        SPID: 8335,
        ArticleID: 8662,
        QTY: 1,
        name: 'آبمیوه گازدار برند عالیس با طعم انگور قرمز۱ لیتری باکس ۶ عددی',
        price: 331500,
        image: ''
      }
    ]
  }
]
